import * as React from 'react';
export default function MyComponent() {
  /// preview-start
  return <div>Hello World!</div>;
  /// preview-end
}
